const { escapeHtml } = Slick;export {
     escapeHtml
};